module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "paralef"
  }, [_c('strong', [_vm._v("Suzanne Harrison")]), _vm._v(" is an Australian journalist and editor who has lived in Hong Kong since 1999. She most recently worked freelance, writing lifestyle and news features for the "), _c('em', [_vm._v("South China Morning Post")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_vm._v("Follow Suzanne on Instagram"), _c('br'), _c('a', {
    attrs: {
      "href": "mailto:@suzannejs.455"
    }
  }, [_vm._v("@suzannejs.455")]), _c('br'), _vm._v("or on Twitter"), _c('br'), _c('a', {
    attrs: {
      "href": "https://twitter.com/suzannej123?lang=en",
      "target": "_blank"
    }
  }, [_vm._v("@suzannej123")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-417e2834","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 63
// module chunks = 0